import { EpimsBaseEntityDto } from './epim-base.dto';
export class IncidentResponseDto extends EpimsBaseEntityDto {


  EventTypeId: string;

  OwnerId: string;

  OwnerName: string;

  OwnerResponse: string;

  IncidentTrackingNo: string;

  ActionTaken: string;

    length : number;

}
